<template>
  <div>
    <Card>
      <Row :style="{marginTop: '20px'}">
        <Col span="18">
          <Form inline :model="fault.searchForm" :label-width="70">
            <FormItem label="创建时间">
              <DatePicker v-model="fault.searchForm.start" type="date" style="width: 150px"></DatePicker>
            </FormItem>
            <FormItem label="结束时间">
              <DatePicker v-model="fault.searchForm.end" type="date" style="width: 150px"></DatePicker>
            </FormItem>
            <FormItem label="创建人">
              <Select v-model="fault.searchForm.endpoints" filterable multiple placeholder="" style="width:150px">
                <Option v-for="item in allServerData" :value="item.endpoint" :key="item.endpoint">{{ item.endpoint }}</Option>
              </Select>
            </FormItem>
            <FormItem label="标签">
              <Select v-model="fault.searchForm.tag" filterable clearable placeholder="" style="width: 150px;">
                <Option v-for="item in allTemplateData" :value="item.template.id" :key="item.template.id" :label="item.template.tpl_name"></Option>
              </Select>
            </FormItem>
            <FormItem :label-width="0">
              <Button type="primary" @click="getFaultData()">搜索</Button>
              <Button @click="faultSearchFormReset" style="margin-left: 10px">重置</Button>
            </FormItem>
          </Form>
        </Col>
        <Col :span="6"><Button type="primary" :style="{float: 'right'}" @click="getFaultData()" icon="md-refresh">刷新</Button></Col>
        <Button type="primary" :style="{float: 'right'}" @click="faultChangeModalShow(true)">添加故障</Button>
      </Row>
      <Table
        border
        :loading="faultLoading"
        :data="fault.data"
        :columns="fault.columns">
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: right;">
          <page
            :total="fault.count"
            :current="fault.page"
            :page-size="fault.searchForm.offset"
            @on-change="getFaultData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
export default {
  name: 'fault',

  data () {
    return {
      faultLoading: false,
      faultChangeModal: false,
      fault: {
        searchForm: {
          start: '',
          end: '',
          creator: '',
          tag: '',
          limit: 10,
          offset: 1
        },
        count: 0,
        page: 1,
        data: [],
        columns: []
      }
    }
  },
  methods: {
    getFaultData () {

    },
    faultSearchFormReset () {
      this.fault = {
        searchForm: {
          start: '',
          end: '',
          creator: '',
          tag: '',
          limit: 10,
          offset: 1
        }
      }
    },
    faultChangeModalShow (change = true) {
      this.faultChangeModal = change
    }
  }
}
</script>

<style scoped>

</style>
